import React from "react";

function HeaderBackground(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1280 665"
      {...props}
    >
      <defs>
        <linearGradient id="b" x1="50%" x2="50%" y1="100%" y2="0%">
          <stop offset="0%" stopColor="#5D21D3"></stop>
          <stop offset="100%" stopColor="#3721D2"></stop>
        </linearGradient>
        <path
          id="a"
          d="M1280 0v583.978c-145.7 5.518-246.367 11.767-302 18.749-169.673 21.293-239.917 42.846-338 54.395-41.9 4.934-243.397 17.388-416.461-27.38C145.939 609.67 71.426 594.414 0 583.978V0h1280z"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <mask id="c" fill="#fff">
          <use xlinkHref="#a"></use>
        </mask>
        <use fill="url(#b)" xlinkHref="#a"></use>
        <path
          fill="#EBF6F1"
          d="M-276.617 464.175c-2.033-37.069-4.045-74.141-6.05-111.213-3.66-67.558-7.317-135.14-8.202-202.79-.337-25.974-.292-52.107 3.487-77.867 3.465-23.567 6.92-47.209 26.637-63.039 39.02-31.33 92.154-46.744 141.171-53.105 32.56-4.225 65.375-4.131 98.172-4.037 14.153.04 28.3.08 42.425-.226 83.589-1.814 186.818-6.5 252.314 53.408 26.818 24.525 38.141 59.833 65.418 83.426 24.04 20.795 53.731 26.402 82.678 37.25 29.769 11.156 58.92 26.267 80.057 50.506 18.43 21.143 29.15 47.329 38.64 73.328 9.167 25.093 15.406 54.687 35.582 73.6 16.468 15.434 39.054 20.746 59.362 29.196 22.188 9.229 44.254 24.9 58.749 44.162 24.636 32.723 14.854 77.952 37.622 111.528 20.845 30.74 57.588 45.402 88.004 64.58 26 16.399 52.61 39.572 61.892 70.39 11.624 38.6-4.759 67.78-44.7 74.39-27.177 4.495-54.61 3.88-82.041 3.259-16.33-.369-32.665-.737-48.951-.022-38.556 1.681-76.913 2.725-115.751 4.627-90.729 4.434-181.811 2.643-272.247 12.205-2.713.286-5.427.582-8.134.89-53.466 6.061-105.064 12.48-157.32 25.29-57.731 14.144-115.11 29.658-172.471 45.204-38.34 10.386-77.339 21.195-117.05 19.755-39.705-1.434-81.03-17.194-103.25-49.952-18.707-27.575-21.393-62.542-23.426-95.745-4.471-72.983-8.605-145.988-12.617-218.998z"
          mask="url(#c)"
          opacity="0.079"
        ></path>
      </g>
    </svg>
  );
}

export default HeaderBackground;
